import React from "react";

import { Grid } from "@mui/material";
import { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import { Despatch, DespatchShipmentContainer } from "../../../../../../../models/despatch";
import { DespatchViewGridData } from "../GridData";

type DespatchViewProductsProps = {
  despatch: Despatch | null;
};

export const DespatchViewProducts: React.FC<DespatchViewProductsProps> = (props) => {
  const { despatch } = props;
  const { t: translate } = useTranslation();

  const columns: Column[] = [
    {
      name: "purchaseOrderId",
      title: `${translate("order")} #`,
    },
    {
      name: "container",
      title: `${translate("sku")} #`,
      formatComponent: (value: DespatchShipmentContainer) => value?.product?.sku,
    },
    {
      name: "container",
      title: translate("productName"),
      formatComponent: (value: DespatchShipmentContainer) => value?.product?.description,
    },
    {
      name: "status",
      title: translate("status"),
    },
    {
      name: "productQuantity",
      title: translate("stocksToDespatch"),
    },
    {
      name: "palletsQuantity",
      title: translate("palletsToDespatch"),
    },
  ];

  return (
    <Grid container direction="column" wrap="nowrap" data-cy="view-products-container">
      <DespatchViewGridData data={despatch?.products} columns={columns} />
    </Grid>
  );
};
